module.exports = __webpack_public_path__ + "static/media/call-icon.184f3aa6.svg";